import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box } from '@material-ui/core';

interface ConfirmacionProp {
    id:string;
    titulo:string;
    texto:string;
    open:boolean;
    callbackCerrar():any;
    callbackCerrarConfirm():any;
    callbackAceptarConfirm?():any;
    bottonAceptar:boolean;
    bottonAceptarCancelar?:boolean;
}



export const Confirmacion = (props:ConfirmacionProp) => {


  return(
    <div id={props.id}>
<Dialog
open={props.open}
onClose={props.callbackCerrar}
aria-labelledby="alert-dialog-title"
aria-describedby="alert-dialog-description"
>
<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
<DialogContent>
  <DialogContentText id="alert-dialog-description">
    {props.texto}
  </DialogContentText>
</DialogContent>
<DialogActions>
 {props.bottonAceptarCancelar  
   &&
   <Button  onClick={props.callbackCerrarConfirm} style= {{textTransform: 'capitalize'}} color="primary" autoFocus>
     Aceptar
 </Button>

 } 
 {
   !props.bottonAceptarCancelar
   &&
   <Button onClick={props.callbackCerrarConfirm}  style= {{textTransform: 'capitalize'}} color="primary">
      Cancelar
   </Button> 
 }
  
  {props.bottonAceptar 
  && 
  <Button onClick={props.callbackAceptarConfirm}  style= {{textTransform: 'capitalize'}} color="primary" autoFocus>
    Aceptar
  </Button>}
</DialogActions>
</Dialog>
</div>
  )

}



